import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { loadJournalDocument } from "@/journalBootstrap";

// Global wallet sync bridge:
// When any hub writes to localStorage.userCredits after an inference,
// dispatch a custom event so MySolutionsPage / wallet UI re-fetch v2 balances.
(() => {
  if (typeof window === 'undefined' || window.__wallet_sync_patched__) return;
  window.__wallet_sync_patched__ = true;
  const origSet = window.localStorage.setItem.bind(window.localStorage);
  window.localStorage.setItem = (key, value) => {
    const prev = window.localStorage.getItem(key);
    origSet(key, value);
    if (key === 'userCredits' && prev !== String(value)) {
      window.dispatchEvent(new CustomEvent('medetechni:wallet-refresh'));
    }
  };
})();

import { ThemeProvider } from "@/context/ThemeContext";

const isJournal = window.location.pathname === '/journal' || window.location.pathname.startsWith('/journal/');
if (isJournal) {
  loadJournalDocument();
} else {
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);

// Register Service Worker for offline resilience
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (reg) => console.log('[SW] Registered:', reg.scope),
      (err) => console.log('[SW] Registration failed:', err)
    );
  });
}


}
